import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/utils/axiosInstance";
import { handleThunkError } from "@/utils/thunkErrorHandler";
import type { Params } from "@/types";

const endpoint = {
  // use front /api proxy so requests go to Next API routes (same-origin)
  overview: "/admin/asaas/payments",
  refund: (paymentId: string) => `/admin/asaas/payments/${paymentId}/refund`,
};

export interface PaymentsOverviewQuery extends Partial<Params> {
  email?: string;
  establishmentId?: number | string;
  page?: number;
  limit?: number;
}

export const fetchAsaasPaymentsOverview = createAsyncThunk(
  "asaasPayments/fetchOverview",
  async (query: PaymentsOverviewQuery, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.overview, {
        params: query,
      });
      return response.data;
    } catch (error) {
      return handleThunkError(error, thunkAPI, "Erro ao carregar pagamentos");
    }
  },
);

export const refundAsaasPayment = createAsyncThunk(
  "asaasPayments/refundPayment",
  async (
    {
      paymentId,
      establishmentId,
      body,
    }: { paymentId: string; establishmentId?: number | string; body?: any },
    thunkAPI,
  ) => {
    try {
      const url = endpoint.refund(paymentId);
      // send establishmentId either in body or as query depending on caller; here we send body
      const response = await axiosInstance.post(
        url,
        body || { establishmentId },
      );
      return response.data;
    } catch (error) {
      return handleThunkError(error, thunkAPI, "Erro ao estornar pagamento");
    }
  },
);
